import { render, staticRenderFns } from "./index.vue?vue&type=template&id=23d90867&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=23d90867&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d90867",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d90867')) {
      api.createRecord('23d90867', component.options)
    } else {
      api.reload('23d90867', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=23d90867&scoped=true&", function () {
      api.rerender('23d90867', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/MatrixInput/index.vue"
export default component.exports